import React from 'react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';

import {useReservation} from 'context/reservation';
import {useStoredURLParams} from 'context/storedURLParams';
import {getHousingName} from 'utils/reservation';

import {
  ModalStyled,
  Row,
  ModalHeader,
  ModalBody,
  WrapperCopyLink,
  InputShareLink,
  ButtonCopy,
  LinkBlackButton,
  ButtonsWrapper,
} from './styled';

import {
  EMAIL_SHARE_LINK,
  LINK_COPIED_MESSAGE_TIMEOUT_MS,
  SMS_SHARE_LINK,
  WHATSAPP_SHARE_LINK,
} from 'utils/constants';

import statusShareImg from 'assets/img/status-share-link-icon.png';

function getEmailSubjectAndBody(reservation = {}, shareLink = '') {
  const housingName = getHousingName(reservation);

  return {
    subject: i18next.t('complete_online_checkin_email_subject'),
    body: i18next.t(`complete_online_checkin_email_body`, {housingName, link: shareLink}),
  };
}

function getShareMessage(reservation = {}, shareLink = '') {
  const housingName = getHousingName(reservation);

  return encodeURI(
    i18next.t('complete_iden_verif_whatsapp', {
      housingName,
      link: shareLink,
    }),
  );
}

export function ShareModal() {
  const {t} = useTranslation();
  const linkInputRef = React.useRef<HTMLInputElement>(null);
  const timeoutRef = React.useRef<any>(0);
  const {data: reservation} = useReservation();
  const {shortShareLink} = useStoredURLParams();
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    if (isCopied) {
      timeoutRef.current = setTimeout(() => {
        setIsCopied(false);
      }, LINK_COPIED_MESSAGE_TIMEOUT_MS);
    }

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [isCopied]);

  const copyLinkToClipboard = () => {
    linkInputRef.current?.select();
    document.execCommand('copy');
    setIsCopied(!isCopied);
  };

  const shareByWhatsapp = () => {
    window.open(
      `${WHATSAPP_SHARE_LINK}?text=${getShareMessage(reservation, shortShareLink)}`,
    );
  };

  const shareBySMS = () => {
    window.open(
      `${SMS_SHARE_LINK};?&body=${getShareMessage(reservation, shortShareLink)}`,
    );
  };

  const shareByEmail = () => {
    const email = getEmailSubjectAndBody(reservation, shortShareLink);
    window.open(`${EMAIL_SHARE_LINK}?subject=${email.subject}&body=${email.body}`);
  };

  return (
    <ModalStyled>
      <ModalHeader>
        <Row>
          <img src={statusShareImg} alt={t('share_checkin_link')} />
        </Row>
        <Row className="modalTitle">
          <span>{t('share_checkin_link')}</span>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row style={{width: '100%'}}>
          <WrapperCopyLink>
            <InputShareLink
              readOnly
              ref={linkInputRef}
              onClick={copyLinkToClipboard}
              value={shortShareLink}
            />

            <ButtonCopy onClick={copyLinkToClipboard}>
              {isCopied ? <span>{t('copied')}</span> : <span>{t('copy_link')}</span>}
            </ButtonCopy>
          </WrapperCopyLink>
        </Row>
        <Row style={{paddingTop: '50px', fontSize: '14px'}}>{t('or_share_by')}</Row>
        <ButtonsWrapper>
          <LinkBlackButton onClick={shareByEmail}>Email</LinkBlackButton>
          <LinkBlackButton onClick={shareByWhatsapp}>WhatsApp</LinkBlackButton>
          <LinkBlackButton onClick={shareBySMS}>SMS</LinkBlackButton>
        </ButtonsWrapper>
      </ModalBody>
    </ModalStyled>
  );
}
